import { convertDateRangeToDates } from "@wingspanhq/fe-component-library";
import { ApiQueryListWorkLogs } from "../../../../../services/workLog";
import { Filter } from "./types";

export function createListRequest(
  userId: string,
  filter?: Filter
): ApiQueryListWorkLogs {
  const request: ApiQueryListWorkLogs = {
    // "filter[payerId]": userId
  };

  // Status filter
  // if (filter?.status === "submitted") {
  //   request["filter[invoiceId][exists]"] = true;
  // } else if (filter?.status === "in-progress") {
  //   request["filter[invoiceId][exists]"] = false;
  // }

  // Contractor filter
  if (filter?.payeeId) {
    request["filter[payeeId]"] = filter.payeeId;
  }

  if (filter?.dateRange) {
    const dateRange = convertDateRangeToDates(filter.dateRange);
    if (dateRange) {
      request["filter[startDate][>]"] = dateRange.start;
      request["filter[startDate][<]"] = dateRange.end;
    }
  }

  return request;
}
